"use strict";
/**
 * @license
 * Copyright 2019 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ponyfill_1 = require("web-streams-polyfill/ponyfill");
function blobToReadableStream(blobPromise) {
    var underlyingSource = {
        start: function (controller) {
            var reader = new FileReader();
            reader.onload = function () {
                controller.enqueue(new Uint8Array(reader.result));
            };
            reader.onerror = function () {
                controller.error(reader.error);
            };
            blobPromise.then(function (blob) { return reader.readAsArrayBuffer(blob); });
        },
    };
    return typeof ReadableStream === "undefined"
        ? new ponyfill_1.ReadableStream(underlyingSource)
        : new ReadableStream(underlyingSource);
}
exports.blobToReadableStream = blobToReadableStream;
//# sourceMappingURL=blobReadableStreamAdapter.js.map